import React from 'react';

import { TiBatteryLow } from 'react-icons/ti'
import module_status_icon_fix from 'static/images/icon/module_status_icon_fix.png';
import module_status_icon_cali from 'static/images/icon/module_status_icon_cali.png';

const ModuleStatusIcon = ({ battery, moduleStatus }) => {

  return (
    <>
      { battery < 20 && <TiBatteryLow />}
      { moduleStatus === 'fix' && <img className="statusicon" src={module_status_icon_fix} alt="fix" />}
      { moduleStatus === 'cali' && <img className="statusicon" src={module_status_icon_cali} alt="cali" />}
    </>
  )
}

export default ModuleStatusIcon;